import { CREATOR_FILTER_DATE_RANGE } from '@/entities/discovery';
import { ConstMap } from '@/shared/utils/const-map';
import type { ManipulateType } from 'dayjs';
import dayjs from 'dayjs';

/**
 * 날짜 범위 enum별 설정
 * 새로운 날짜 범위를 추가할 때는 이 config만 수정하면 됩니다.
 */
export const DATE_RANGE_CONFIG = new ConstMap<
  CREATOR_FILTER_DATE_RANGE,
  {
    value: number | null;
    unit: ManipulateType;
    label: string;
  }
>([
  [
    CREATOR_FILTER_DATE_RANGE.ALL_TIME,
    {
      value: null,
      unit: 'day',
      label: 'All time',
    },
  ],
  [
    CREATOR_FILTER_DATE_RANGE.LAST_14_DAYS,
    {
      value: 14,
      unit: 'day',
      label: 'Last 14 days',
    },
  ],
  [
    CREATOR_FILTER_DATE_RANGE.LAST_30_DAYS,
    {
      value: 30,
      unit: 'day',
      label: 'Last 30 days',
    },
  ],
  [
    CREATOR_FILTER_DATE_RANGE.LAST_60_DAYS,
    {
      value: 60,
      unit: 'day',
      label: 'Last 60 days',
    },
  ],
]);

export const parseDateRangeToEnum = (
  {
    start_date,
    end_date,
  }: {
    start_date?: DateISOString | null;
    end_date?: DateISOString | null;
  },
  defaultTimeRange: CREATOR_FILTER_DATE_RANGE,
) => {
  if (start_date === null && end_date === null) return CREATOR_FILTER_DATE_RANGE.ALL_TIME;
  const isToday = dayjs(end_date).isSame(dayjs(), 'date');
  const diffDate = dayjs(end_date).diff(dayjs(start_date), 'day');

  if (!isToday) {
    console.warn(`[parseDateRangeToEnum] End date is not equal to today, ${diffDate}`);
    return defaultTimeRange;
  }

  // config를 순회하며 매칭되는 enum 찾기
  const matchedEntry = DATE_RANGE_CONFIG.toArray().find((config) => {
    return config.value.value === diffDate && config.value.unit === 'day';
  });

  if (matchedEntry) {
    return matchedEntry.key;
  }

  console.warn(`[parseDateRangeToEnum] Invalid dateRange, ${diffDate}`);
  return defaultTimeRange;
};

export const parseDateRangeEnum = (dateRangeEnum: CREATOR_FILTER_DATE_RANGE) => {
  const config = DATE_RANGE_CONFIG.get(dateRangeEnum);

  if (!config) {
    throw new Error(`[parseDateRangeEnum] Invalid dateRangeEnum: ${dateRangeEnum}`);
  }

  if (config.value === null)
    return {
      start_date: null,
      end_date: null,
    };

  return {
    start_date: dayjs().subtract(config.value, config.unit).toISOString(),
    end_date: dayjs().toISOString(),
  };
};
